module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inCart) ? _c('div', {
    staticClass: "ui grid segment container"
  }, [_c('div', {
    staticClass: "ui form sixteen wide column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('h3', {
    staticClass: "ui header"
  }, [_vm._v(_vm._s(_vm.lang.say('TABLE_HEADING_COMMENTS')))]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "comments"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b2cfd7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comment.vue
// module id = 374
// module chunks = 0